import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getEventBySlug } from '../app/store/slices/event/event';
import { getTicketsByEventId } from '../app/store/slices/ticket/ticket';

export default function useEventPreview() {
    const { eventSlug } = useParams();
    const dispatch = useDispatch();
    const eventScheduleRef = useRef(null);
    const { user } = useSelector((state) => state.auth);
    const [showTicketPreview, setShowTicketPreview] = useState(false);
    const [loading, setLoading] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchEvent = async () => {
            if (eventSlug && user?.id) {
                try {
                    setLoading(true);

                    const eventData = await dispatch(getEventBySlug(eventSlug)).unwrap();

                    // console.log("Response -> ", eventData)

                    setPreviewData(eventData?.data);

                    const ticketData = await dispatch(
                        getTicketsByEventId(eventData?.data?.eventId)
                    ).unwrap();

                    // const ticketData = await dispatch(getTicketsByEventId(71)).unwrap();

                    const minTicketPrice = Math.min(
                        ...ticketData?.data?.map((ticket) => parseFloat(ticket.price))
                    );

                    setPreviewData((prev) => ({
                        ...prev,
                        tickets: ticketData?.data || [],
                        minTicketPrice: minTicketPrice
                    }));

                    setIsError(false);

                    // console.log('Tickets -> ', ticketData);
                } catch (error) {
                    setIsError(true);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchEvent();
    }, [user?.id]);

    function scrollToEventSchedule() {
        eventScheduleRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    // console.log("Preview Data -> ", previewData);

    return {
        isError,
        showTicketPreview,
        setShowTicketPreview,
        loading,
        previewData,
        scrollToEventSchedule,
        eventScheduleRef
    };
}
